import { useEffect, useState } from "react";
import Header from "@/components/layout/Header";
import MainContent from "@/components/layout/MainContent";
import LoadingState from "@/components/layout/LoadingState";
import { useProfile } from "@/hooks/useProfile";
import { supabase } from "@/integrations/supabase/client";

const Index = () => {
  const [session, setSession] = useState<any>(null);
  const profile = useProfile(session);

  useEffect(() => {
    profile.loadProfile();
    
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      if (!session) {
        profile.setCategories([]);
        profile.setBusinessName("");
        profile.setBusinessPhone("");
        profile.setBusinessWebsite("");
        profile.setBusinessDescription("");
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  if (profile.isLoading) {
    return <LoadingState />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-purple-50 relative overflow-hidden">
      <div className="absolute inset-0 bg-grid-black/[0.02] -z-10" />
      <div className="absolute inset-0 flex items-center justify-center -z-10 overflow-hidden">
        <div className="w-full h-full max-w-7xl mx-auto relative">
          <div className="absolute max-w-[300px] sm:max-w-[400px] aspect-square top-0 -left-4 bg-purple-300 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob" />
          <div className="absolute max-w-[300px] sm:max-w-[400px] aspect-square top-0 -right-4 bg-yellow-300 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-2000" />
          <div className="absolute max-w-[300px] sm:max-w-[400px] aspect-square -bottom-8 left-20 bg-pink-300 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-4000" />
        </div>
      </div>

      <div className="container max-w-7xl mx-auto px-2 sm:px-4 py-2 sm:py-6 relative overflow-x-hidden">
        <Header session={session} />
        <MainContent
          session={session}
          isEditing={profile.isEditing}
          categories={profile.categories}
          address={profile.address}
          latitude={profile.latitude}
          longitude={profile.longitude}
          businessName={profile.businessName}
          businessPhone={profile.businessPhone}
          businessWebsite={profile.businessWebsite}
          businessDescription={profile.businessDescription}
          onCategoriesChange={profile.setCategories}
          onEditToggle={profile.handleEditToggle}
          onSaveProfile={profile.saveProfile}
          onLocationSelect={profile.handleLocationSelect}
          onBusinessNameChange={profile.setBusinessName}
          onBusinessPhoneChange={profile.setBusinessPhone}
          onBusinessWebsiteChange={profile.setBusinessWebsite}
          onBusinessDescriptionChange={profile.setBusinessDescription}
        />
      </div>
    </div>
  );
};

export default Index;